import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/tenant-profile/general')({
  component: lazyRouteComponent(() => import('&/features/settings/organization/pages/tenant-general-page')),
  staticData: { titleKey: 'tenantProfile' },
});
